import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import ActionsMenu from "../../../../../ui/ActionsMenu";
import Button from "../../../../../ui/Button";
import SquareButton from "../../../../../ui/SquareButton";

import CachedIcon from "@material-ui/icons/Cached";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

const useStyles = makeStyles({
  navbar: {
    backgroundColor: "#ffffff",
    display: "flex",
    justifyContent: "space-between",
    padding: "11px",
    width: "100%",
    marginBottom: "10px",
    boxSizing: "border-box",
    "& div": {
      display: "flex",
      justifyContent: "center",
      "& button": {
        marginRight: "14px",
        fontSize: "12px"
      }
    }
  }
});

const Navbar = ({ showDeleteModal,
                  goBack,
                  saveModule,
                  notViewSaveButton,
                  sendToExpertise,
                  sendToDevelop,
                  approveExpertise,
                  rejectExpertise,
                  sendToPublication,
                  approvePublication,
                  rejectPublication,
                  disabled,
                  reload,
                  isUpdating,
                  statusId, created}) => {
  const { navbar } = useStyles();
  const actions = [
    {
      label: "Создать копию",
      onClick: "cloneSkill"
    },
    {
      label: "Удалить",
      onClick: showDeleteModal
    }
  ];

  const ActionButton = ({state}) => {
    if (state === 1) {
      return (
      <>
        <Button
          onClick={saveModule}
          disabled={disabled || isUpdating || saveModule == null}
          loading={isUpdating}
          color="green">
          Сохранить
        </Button><div></div>
        {created &&
        <Button
          onClick={sendToExpertise}
          disabled={disabled || isUpdating || sendToExpertise == null}
          color="blue">
          НА ЭКСПЕРТИЗУ
        </Button>}
      </>
      );
    } else if (state === 2) {
      return (
        <>
          <Button
            onClick={sendToDevelop}
            disabled={disabled || isUpdating || sendToDevelop == null}
            color="blue">
            НА ДОРАБОТКУ
          </Button>
          <div></div>
          <Button
            onClick={approveExpertise}
            disabled={disabled || isUpdating || approveExpertise == null}
            color="green">
            ПОДТВЕРДИТЬ
          </Button>
          <div></div>
          <Button
            onClick={rejectExpertise}
            disabled={disabled || isUpdating || rejectExpertise == null}
            color="pink">
            ОТКЛОНИТЬ
          </Button>
        </>
      );
    } else if (state === 3) {
      return (
        <Button
          onClick={sendToPublication}
          disabled={disabled || isUpdating || sendToPublication == null}
          color="blue">
          НА ПУБЛИКАЦИЮ
        </Button>
      )
    } else if (state === 5) {
      return (
        <>
          <Button
            onClick={approvePublication}
            disabled={disabled || isUpdating || approvePublication == null}
            color="green">
            ОПУБЛИКОВАТЬ
          </Button>
          <div></div>
          <Button
            onClick={rejectPublication}
            disabled={disabled || isUpdating || rejectPublication == null}
            color="pink">
            ОТКЛОНИТЬ
          </Button>
        </>
      )
    }
    return <></>
  };

  return (
    <nav className={navbar}>
      <div>
        <SquareButton onClick={goBack}>
          <ChevronLeftIcon fontSize="small" />
        </SquareButton>
        <SquareButton>
          <CachedIcon
            fontSize="small"
            onClick={reload}
          />
        </SquareButton>
      </div>
      <div>
        <ActionButton state={statusId}/>
        <ActionsMenu actions={actions} />
      </div>
    </nav>
  );
};

export default Navbar;
